export default __webpack_public_path__ + "app/assets/daweiCatRtoL-24e8622b.gif";